import $ from 'jquery';

class SelectTab {
    constructor(el) {
        this.DOM = {el: el};

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.el.addEventListener('change', (e) => {
            $(e.target.value).tab('show');
        });
    }
}

const tabNodes = Array.from(document.querySelectorAll('[data-select-tab]'));
if (tabNodes !== null) {
    tabNodes.forEach((tab) => { new SelectTab(tab); });
}
